import { createSvgIcon } from '@mui/material';

export const GooglePayIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19685_71173)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#EBF2FD'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M25.6683 18.8119H24.7506V11.5312H27.1836C27.8003 11.5312 28.3261 11.7407 28.7563 12.1598C29.1961 12.5789 29.4159 13.0906 29.4159 13.6949C29.4159 14.3138 29.1961 14.8255 28.7563 15.2397C28.3309 15.654 27.805 15.8587 27.1836 15.8587H25.6683V18.8119ZM25.6683 12.4279V14.9668H27.2028C27.566 14.9668 27.872 14.8401 28.111 14.5916C28.3548 14.3431 28.479 14.0409 28.479 13.6998C28.479 13.3635 28.3548 13.0663 28.111 12.8177C27.872 12.5594 27.5708 12.4327 27.2028 12.4327H25.6683V12.4279Z'
        fill='#3C4043'
      />
      <path
        d='M31.8155 13.6657C32.4942 13.6657 33.0296 13.8509 33.4216 14.2212C33.8135 14.5916 34.0095 15.0984 34.0095 15.7417V18.8119H33.1348V18.1198H33.0965C32.7189 18.69 32.2122 18.9727 31.5812 18.9727C31.0411 18.9727 30.5918 18.8119 30.2285 18.4853C29.8652 18.1588 29.6835 17.7544 29.6835 17.267C29.6835 16.7505 29.8747 16.3411 30.2571 16.039C30.6396 15.7319 31.151 15.5809 31.7868 15.5809C32.3317 15.5809 32.781 15.6832 33.13 15.8879V15.6735C33.13 15.347 33.0057 15.0741 32.7524 14.845C32.499 14.616 32.2026 14.5039 31.8633 14.5039C31.3518 14.5039 30.9455 14.7232 30.6491 15.1666L29.8413 14.6501C30.2858 13.9922 30.9455 13.6657 31.8155 13.6657ZM30.63 17.2816C30.63 17.5253 30.7304 17.73 30.9359 17.8908C31.1367 18.0516 31.3757 18.1345 31.6482 18.1345C32.0353 18.1345 32.3795 17.9883 32.6807 17.6959C32.9818 17.4035 33.1348 17.0623 33.1348 16.6676C32.848 16.4386 32.4512 16.3216 31.9397 16.3216C31.5669 16.3216 31.2562 16.4142 31.0076 16.5945C30.7543 16.7846 30.63 17.0136 30.63 17.2816Z'
        fill='#3C4043'
      />
      <path
        d='M39 13.8265L35.9407 21H34.9943L36.1319 18.4903L34.1147 13.8265H35.1138L36.5669 17.4035H36.5861L38.001 13.8265H39Z'
        fill='#3C4043'
      />
      <path
        d='M22.0177 15.269C22.0177 14.9639 21.9909 14.672 21.9412 14.3913H18.0942V15.9995L20.3098 16C20.2199 16.5351 19.9307 16.9912 19.4876 17.2953V18.3387H20.8064C21.5765 17.6121 22.0177 16.538 22.0177 15.269Z'
        fill='#4285F4'
      />
      <path
        d='M19.4881 17.2953C19.121 17.5478 18.6482 17.6954 18.0952 17.6954C17.0268 17.6954 16.1205 16.9615 15.7959 15.9723H14.4355V17.0483C15.1095 18.4118 16.4948 19.3475 18.0952 19.3475C19.2013 19.3475 20.1305 18.9766 20.8069 18.3382L19.4881 17.2953Z'
        fill='#34A853'
      />
      <path
        d='M15.6678 15.1739C15.6678 14.8962 15.7132 14.6277 15.7959 14.3752V13.2992H14.4355C14.1568 13.863 14 14.4995 14 15.1739C14 15.8484 14.1573 16.4849 14.4355 17.0487L15.7959 15.9727C15.7132 15.7202 15.6678 15.4517 15.6678 15.1739Z'
        fill='#FABB05'
      />
      <path
        d='M18.0952 12.652C18.6989 12.652 19.2395 12.864 19.6664 13.2783L20.8351 12.0877C20.1253 11.4137 19.1998 11 18.0952 11C16.4953 11 15.1095 11.9357 14.4355 13.2992L15.7959 14.3752C16.1205 13.3859 17.0268 12.652 18.0952 12.652Z'
        fill='#E94235'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19685_71173'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19685_71173'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19685_71173'
          result='effect2_dropShadow_19685_71173'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19685_71173'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'GooglePayIcon',
);
